(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function syncPlayButton(btn, paused) {
    if (!btn) return;
    const pauseIcon = btn.querySelector('.pv-ord-social-lightbox__icon--pause');
    const playIcon = btn.querySelector('.pv-ord-social-lightbox__icon--play');
    if (pauseIcon) pauseIcon.hidden = paused;
    if (playIcon) playIcon.hidden = !paused;
    btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    btn.classList.toggle('is-paused', paused);
  }

  function syncMuteButton(btn, muted) {
    if (!btn) return;
    const mutedIcon = btn.querySelector('.pv-ord-social-lightbox__icon--muted');
    const soundIcon = btn.querySelector('.pv-ord-social-lightbox__icon--sound');
    if (mutedIcon) mutedIcon.hidden = !muted;
    if (soundIcon) soundIcon.hidden = muted;
    btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    btn.classList.toggle('is-muted', muted);
  }

  function initAutoScroll(root) {
    const track = root.querySelector('.pv-ord-social__grid');
    if (!track || track.dataset.pvSocialScroll) return;
    track.dataset.pvSocialScroll = '1';
    if (prefersReducedMotion()) return;

    const wrap = root.querySelector('.pv-ord-hscroll-wrap') || track;
    let paused = false;
    let lightboxOpen = false;
    const speed = 0.45;

    const pause = () => {
      paused = true;
    };
    const resume = () => {
      if (!lightboxOpen) paused = false;
    };

    wrap.addEventListener('mouseenter', pause);
    wrap.addEventListener('mouseleave', resume);
    wrap.addEventListener('focusin', pause);
    wrap.addEventListener('focusout', resume);
    wrap.addEventListener(
      'touchstart',
      () => {
        pause();
      },
      { passive: true }
    );
    wrap.addEventListener('touchend', () => {
      window.setTimeout(resume, 1800);
    });

    root.addEventListener('pv-social:lightbox', (event) => {
      lightboxOpen = !!event.detail?.open;
      paused = lightboxOpen;
    });

    const tick = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max > 8 && !paused) {
        track.scrollLeft += speed;
        if (track.scrollLeft >= max - 1) {
          track.scrollLeft = 0;
        }
      }
      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }

  function pauseStripVideos(root, except) {
    root.querySelectorAll('.pv-ord-social-card__video').forEach((video) => {
      if (video === except) return;
      video.pause();
    });
  }

  function resumeStripVideos(root) {
    if (!('IntersectionObserver' in window)) {
      root.querySelectorAll('.pv-ord-social-card__video').forEach((video) => {
        video.muted = true;
        video.play().catch(() => {});
      });
      return;
    }
    root.querySelectorAll('.pv-ord-social-card__video').forEach((video) => {
      const rect = video.getBoundingClientRect();
      const visible = rect.width > 0 && rect.top < window.innerHeight && rect.bottom > 0;
      if (visible) {
        video.muted = true;
        video.play().catch(() => {});
      }
    });
  }

  function clearStage(stage) {
    while (stage.firstChild) stage.removeChild(stage.firstChild);
  }

  function buildShopifyLightboxVideo(sourceVideo) {
    const video = document.createElement('video');
    video.className = 'pv-ord-social-lightbox__video';
    video.controls = false;
    video.playsInline = true;
    video.loop = true;
    video.autoplay = true;
    video.muted = false;
    video.setAttribute('playsinline', '');

    const sources = sourceVideo.querySelectorAll('source');
    if (sources.length) {
      sources.forEach((src) => {
        const clone = src.cloneNode(true);
        video.appendChild(clone);
      });
    } else if (sourceVideo.currentSrc || sourceVideo.src) {
      video.src = sourceVideo.currentSrc || sourceVideo.src;
    }

    if (sourceVideo.poster) video.poster = sourceVideo.poster;
    return video;
  }

  function buildEmbed(type, id) {
    const iframe = document.createElement('iframe');
    iframe.className = 'pv-ord-social-lightbox__embed';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
    iframe.title = 'Social video';
    if (type === 'youtube') {
      iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=0&controls=0&rel=0&playsinline=1&enablejsapi=1`;
    } else {
      iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1&muted=0&loop=1`;
    }
    return iframe;
  }

  function initLightbox(root) {
    const lightbox = root.querySelector('[data-pv-social-lightbox]');
    if (!lightbox || lightbox.dataset.pvSocialLbReady) return;
    lightbox.dataset.pvSocialLbReady = '1';

    const stage = lightbox.querySelector('[data-pv-social-stage]');
    const playBtn = lightbox.querySelector('[data-pv-social-lb-play]');
    const muteBtn = lightbox.querySelector('[data-pv-social-lb-mute]');
    const closeEls = lightbox.querySelectorAll('[data-pv-social-close]');
    let activeVideo = null;
    let activeEmbed = null;
    let embedMuted = false;
    let lastFocus = null;

    function setLightboxOpen(open) {
      root.dispatchEvent(new CustomEvent('pv-social:lightbox', { detail: { open }, bubbles: true }));
    }

    function closeLightbox() {
      clearStage(stage);
      activeVideo = null;
      activeEmbed = null;
      lightbox.hidden = true;
      document.documentElement.classList.remove('pv-ord-social-lightbox-open');
      setLightboxOpen(false);
      resumeStripVideos(root);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    function openFromMedia(media) {
      const type = media.dataset.pvSocialType;
      if (!type) return;

      lastFocus = document.activeElement;
      clearStage(stage);
      activeVideo = null;
      activeEmbed = null;
      embedMuted = false;

      pauseStripVideos(root);

      if (type === 'shopify') {
        const sourceVideo = media.querySelector('.pv-ord-social-card__video');
        if (!sourceVideo) return;
        activeVideo = buildShopifyLightboxVideo(sourceVideo);
        stage.appendChild(activeVideo);
        syncPlayButton(playBtn, false);
        syncMuteButton(muteBtn, false);
        activeVideo.addEventListener('play', () => syncPlayButton(playBtn, false));
        activeVideo.addEventListener('pause', () => syncPlayButton(playBtn, true));
        activeVideo.play().catch(() => {
          // Browsers may block unmuted autoplay — fall back to muted then let user unmute
          activeVideo.muted = true;
          syncMuteButton(muteBtn, true);
          activeVideo.play().catch(() => {});
        });
      } else if (type === 'youtube' || type === 'vimeo') {
        const id = media.dataset.pvSocialEmbedId;
        if (!id) return;
        activeEmbed = buildEmbed(type, id);
        stage.appendChild(activeEmbed);
        syncPlayButton(playBtn, false);
        syncMuteButton(muteBtn, false);
        // Embed play/pause is limited without API — hide play for embeds, keep mute+close
        if (playBtn) playBtn.hidden = true;
      }

      if (type === 'shopify' && playBtn) playBtn.hidden = false;

      lightbox.hidden = false;
      document.documentElement.classList.add('pv-ord-social-lightbox-open');
      setLightboxOpen(true);
      const closeBtn = lightbox.querySelector('.pv-ord-social-lightbox__btn--close');
      if (closeBtn) closeBtn.focus();
    }

    root.querySelectorAll('[data-pv-social-open]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const media = btn.closest('[data-pv-social-media]');
        if (media) openFromMedia(media);
      });
    });

    closeEls.forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        closeLightbox();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });

    if (playBtn) {
      playBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (!activeVideo) return;
        if (activeVideo.paused) {
          activeVideo.play().catch(() => {});
        } else {
          activeVideo.pause();
        }
        syncPlayButton(playBtn, activeVideo.paused);
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (activeVideo) {
          activeVideo.muted = !activeVideo.muted;
          if (!activeVideo.muted) activeVideo.play().catch(() => {});
          syncMuteButton(muteBtn, activeVideo.muted);
          return;
        }
        if (activeEmbed) {
          embedMuted = !embedMuted;
          const id = activeEmbed.src.match(/embed\/([^?]+)/)?.[1] || activeEmbed.src.match(/video\/(\d+)/)?.[1];
          const type = activeEmbed.src.includes('youtube') ? 'youtube' : 'vimeo';
          if (id) {
            clearStage(stage);
            activeEmbed = buildEmbed(type, id);
            if (embedMuted) {
              activeEmbed.src = activeEmbed.src
                .replace('mute=0', 'mute=1')
                .replace('muted=0', 'muted=1');
            }
            stage.appendChild(activeEmbed);
          }
          syncMuteButton(muteBtn, embedMuted);
        }
      });
    }
  }

  function initStripVideos(root) {
    const videos = [];
    root.querySelectorAll('.pv-ord-social-card__video').forEach((video) => {
      video.muted = true;
      video.setAttribute('playsinline', '');
      videos.push(video);
    });
    if (!videos.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (document.documentElement.classList.contains('pv-ord-social-lightbox-open')) return;
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio > 0.35) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.35, 0.75] }
    );

    videos.forEach((video) => observer.observe(video));
  }

  function initSection(root) {
    if (!root || root.dataset.pvSocialInit) return;
    root.dataset.pvSocialInit = '1';
    initStripVideos(root);
    initAutoScroll(root);
    initLightbox(root);
  }

  document.querySelectorAll('.pv-ord-social').forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.pv-ord-social') || event.target.closest('.pv-ord-social');
    if (section) {
      delete section.dataset.pvSocialInit;
      const track = section.querySelector('.pv-ord-social__grid');
      if (track) delete track.dataset.pvSocialScroll;
      const lb = section.querySelector('[data-pv-social-lightbox]');
      if (lb) delete lb.dataset.pvSocialLbReady;
      initSection(section);
    }
  });
})();
